import { Box, Button, Dialog, Typography } from "@mui/material";
import PdfPreview from "../../../../components/PdfPreview";

export default function QrPreviewDialog({dialogStatus}) {

  const {isOpen, close, pdfUrl, setPdfUrl} = dialogStatus;

  const handleClose = (_e) => {
    URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
    close();
  }

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={handleClose}
    >
      <Box padding={2}>
        <Typography>
          QRシート　プレビュー
        </Typography>
        <Box height='calc(100vh - 130px)' marginY={1}>
          <PdfPreview
            pdfUrl={pdfUrl}
          />
        </Box>
        <Box textAlign='right' marginTop={1}>
          <Button
            variant="contained"
            onClick={handleClose}
          >
            閉じる
          </Button>
        </Box>
      </Box>     

    </Dialog>

  )
}